// lib/stores/weatherStore.js
import { get, writable } from "svelte/store";
import { fbConfig } from "$lib/data/generated/fbConfig";
import { browser } from "$app/environment";
import { getAreas } from "./getAreas";
// import content from '$lib/data/generated/content.json';

let selectedArea;
let update;
const updateInterval = 15 * 60 * 1000;
const additionalAreas = {};

export const weatherStore = writable({});

export const watchWeather = async inArea => {
    if (!browser) return;
    if (!inArea) return;

    let area;
    const { lat, lon } = inArea;
    if (lat && lon) {
        area = `${lat.toFixed(3)},${lon.toFixed(3)}`;
        additionalAreas[area] = {
            value: { lat: { value: lat }, lon: { value: lon }, label: { value: area } }
        };
    } else {
        area = inArea;
    }
    if (selectedArea === area) return;

    selectedArea = area;

    if (update) clearInterval(update);

    const currentStore = get(weatherStore);
    if (!currentStore[selectedArea]) {

        const weather = await getWeather();

        weatherStore.set({
            [selectedArea]: { ...weather },
            selectedArea
        });

        update = setInterval(updateWeather, updateInterval);
    }
};

export const clearUpdate = () => {
    if (update) clearInterval(update);
};

const updateWeather = async () => {
    const weather = await getWeather();

    weatherStore.set({
        [selectedArea]: { ...weather },
        selectedArea
    });

};

const getWeather = async () => {
    const areas = { ...getAreas().areas, ...additionalAreas };

    try {
        const lat = areas?.[selectedArea]?.value?.lat?.value;
        const lon = areas?.[selectedArea]?.value?.lon?.value;
        const city = areas?.[selectedArea]?.value?.label?.value;

        if (lat === undefined || lon === undefined || !city) {
            console.warn("Missing weather area data:", {
                selectedArea,
                lat,
                lon,
                city,
            });
            return;
        }

        const url = `https://us-central1-${fbConfig.projectId}.cloudfunctions.net/getweather`;
        const request = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ lat, lon, city }),
        };

        const response = await fetch(url, request);

        console.log({ response });

        if (!response.ok) {
            console.warn(
                "Weather API error:",
                response.status,
                response.statusText,
            );
            return;
        }

        return await response.json();
    } catch (err) {
        console.warn("Weather fetch failed:", err);
    }
};



// export const weatherStore = {
//     subscribe: store.subscribe,

//     async fetch(area, { lat, lon, city }) {
//         store.update((state) => {
//             if (state[area]?.status === "loading" || state[area]?.status === "done") {
//                 return state; // skip duplicate
//             }
//             return {
//                 ...state,
//                 [area]: { status: "loading" }
//             };
//         });

//         try {
//             const response = await fetch(`https://us-central1-${fbConfig.projectId}.cloudfunctions.net/getweather`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ lat, lon, city }),
//             });

//             if (!response.ok) throw new Error(`HTTP ${response.status}`);

//             const json = await response.json();

//             store.update((state) => ({
//                 ...state,
//                 [area]: {
//                     status: "done",
//                     description: json.description || "",
//                     icon: json.icon || "",
//                     temp: Math.round(json.temp ?? 0),
//                 },
//             }));
//         } catch (e) {
//             console.warn("Weather fetch failed for", area, e);
//             store.update((state) => ({
//                 ...state,
//                 [area]: { status: "error", error: e.message }
//             }));
//         }
//     }
// };
